export const TRACKING_ADDED_FROM_CATALOG = 'Catalog'
export const TRACKING_ADDED_FROM_RECOMMENDED = 'RecommendedProductList'
export const TRACKING_ADDED_FROM_CANVAS_ACTION = 'CanvasAction'
export const TRACKING_ADDED_FROM_MY_LIST = 'MyList'

export const APP_TYPE_SUGARCUBE = 'Sugarcube'
export const APP_TYPE_MAGICWINDOW = 'MagicWindow'

export const ROOM_SOURCE_USERCAPTURED = 'UserCaptured'
export const ROOM_SOURCE_STOCK = 'Stock'

export const PRODUCT_TYPE_WALLART = 'WallArt'
export const PRODUCT_TYPE_FURNITURE = 'Furniture'

export const PRODUCT_SOURCE_WALLSPICE = 'Wallspice'

export const APP_ENV_PROD = 'Production'
export const APP_ENV_TESTING = 'Testing'

export const PRODUCT_SWAP = 'ProductSwap'
export const TRASH_CAN = 'TrashCan'
export const GET_INFO_CANVAS_PIN = 'CanvasPin'
export const GET_INFO_CATALOG_LIST = 'CatalogList'
export const GET_INFO_ROOM_LIST = 'RoomList'
export const GET_INFO_SWAP_LIST = 'SwapList'
export const GET_INFO_ACTION_PANEL = 'ActionPanel'

export const CATEGORY = 'Category'
export const SUB_CATEGORY = 'Sub-category'
export const FILTER_SOURCE_BREADCRUMB = 'Breadcrumb'
export const FILTER_SOURCE_MENU = 'Menu'

// Optimizely custom events

// Add to cart clicks from the magic window/sugarcube/design lab experience
export const OPTIMIZELY_ADD_TO_CART_MW = 'add_to_cart_mw'
// Add to cart clicks from either magic window or general shopping experience on ikea.com
export const OPTIMIZELY_ADD_TO_CART = 'add_to_cart'
